import {
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Text,
} from '@tonic-one/react';
import { useTranslation } from 'react-i18next';
import { RejectProvisionReason } from '@Types/provision';
import { Service } from '@Types/app';

const RejectProvisionModal = ({
  service,
  reason,
  onClose,
}: {
  service: Service;
  onClose: () => void;
  reason: RejectProvisionReason;
}) => {
  const { t } = useTranslation(['provision', 'common']);

  const text = {
    [RejectProvisionReason.ServiceConflict]: t(
      'provision.error.provisionConflict'
    ),
    [RejectProvisionReason.PocConflict]: t('provision.error.pocConflict'),
  }[reason];

  return (
    <>
      <Modal isOpen={true} isClosable onClose={onClose} size="md">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>{t(`provision.service.${service}.title`)} </ModalHeader>
          <ModalBody>
            <Text>{text}</Text>
          </ModalBody>
          <ModalFooter>
            <Button minWidth="20x" onClick={onClose}>
              {t('common.button.close')}
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};

export default RejectProvisionModal;
